var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more fn-clear item"},[_c('div',{staticClass:"title fn-left"}),_c('div',{staticClass:"content fn-left"},[_c('p',[_vm._v("超过300万粉丝的公众号请联系客服咨询购买。")]),_c('div',[_c('ScrmHelp')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }